import classNames from 'clsx';
import * as React from 'react';

import * as styles from './Filter.css';

type TFilterProps = Pick<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'className'>;

export const Filter: React.FC<TFilterProps> = props => {
  const className = classNames(styles['container'], props.className);

  return <div className={className}>{props.children}</div>;
};
